/**
 * Grok journey — protocol `unidentifiable` (ADR-0159 §3).
 *
 * The honest villain journey: reported residential-IP rotation +
 * spoofed browser UAs (observed / reported, framed as such); no
 * documented bot UA, no signature, no documented commerce capability.
 *
 * Shows what the merchant CANNOT see, and that only a signed handshake
 * (Sill's model) would make this traffic legible. Discovery attempts
 * render honestly; there is no read-menu / mandate / cart / pay tail —
 * the terminal phase caps the journey with the observed-traffic teaching
 * note.
 */

import { buildDiscoveryPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildGrokJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    // ── The teaching phase — what merchants CANNOT see today ──
    {
      id: 'invisible',
      name: 'What you cannot see',
      tier: 'illustration',
      narration:
        `Observed: Grok presents no bot identity — browser-shaped traffic with reported residential-IP rotation. To your access log it looks like any human on Chrome; only a signed handshake would make it legible.`,
      endpoint: {
        method: 'GET',
        path: '(observed)',
        status: 200,
        ms: 0,
        body: '{ "identity": "unidentifiable", "signature": null, "ip_class": "residential (rotated)" }',
        live: false,
      },
      ok: true,
    },
  ];
}
